import * as Types from '../constants/Types';
import { PAGINATION } from '../constants/Define';

const initialState = {
    isSubmit: false,
    isFetching: false,
    isGetItem: false,
    data: {
        pageSize: PAGINATION.pageSize,
        pageIndex: PAGINATION.pageIndex,
        totalCount: PAGINATION.totalCount,
    },
};

export default (state = initialState, action) => {
    switch (action.type) {
        case Types.TOUR_PROPERTY_LIST_ALL_ACTION:
            return { ...state, isFetching: true };
        case Types.TOUR_PROPERTY_LIST_ALL_SUCCESS:
            return { ...state, isFetching: false, allProperties: action.allProperties };
        case Types.TOUR_PROPERTY_CREATE_ACTION:
            return { ...state, isFetching: true, isSubmit: true };
        case Types.TOUR_PROPERTY_CREATE_FAIL:
            return { ...state, isFetching: false };
        case Types.TOUR_PROPERTY_UPDATE_ACTION:
            return { ...state, isFetching: true, isSubmit: true };
        case Types.TOUR_PROPERTY_DELETE_ACTION:
            return { ...state, isFetching: true, isSubmit: true };
        case Types.TOUR_PROPERTY_GET_UPDATE_ACTION:
            return { ...state, isFetchingUpdate: true, isGetItem: true };
        case Types.TOUR_PROPERTY_LIST_ALL_ACTION:
        case Types.TOUR_PROPERTY_LIST_ACTION:
            return { ...state, isFetching: true };
        case Types.PROPERTY_LIST_LOAD_ALL_SUCCESS:
        case Types.TOUR_PROPERTY_LIST_SUCCESS:
            return { ...state, isFetching: false, data: action.properties, isSubmit: false };
        case Types.TOUR_PROPERTY_GET_UPDATE_SUCCESS:
            return { ...state, isFetchingUpdate: false, dataUpdate: action.dataUpdate, isSubmit: false, isGetItem: false };
        case Types.TOUR_PROPERTY_UPDATE_SUCCESS:
            return { ...state, isFetching: false, isSubmit: false };
        case Types.TOUR_PROPERTY_CREATE_TRANSLATE_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.TOUR_PROPERTY_CREATE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingUpdate: false };
        case Types.TOUR_PROPERTY_DELETE_TRANSLATE_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.TOUR_PROPERTY_DELETE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingUpdate: false };
        case Types.TOUR_PROPERTY_UPDATE_TRANSLATE_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.TOUR_PROPERTY_UPDATE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingUpdate: false };
        case Types.TOUR_PROPERTY_FAIL:
            return { ...state, isFetching: false, isFetchingUpdate: false, isGetItem: false, isSubmit: false };
        default:
            return state;
    }
}
